import { PayloadAction } from '@reduxjs/toolkit';

import { ActionTypes } from './blogConfig';
import { BlogState } from './blogInterface';

const initialState: BlogState = {
    blogs: 'loading'
};
const reducer = (state: BlogState, action: PayloadAction<any>): BlogState => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.UPDATE_BLOGS:
            return {
                ...state,
                blogs: payload
            };
        case ActionTypes.UPDATE_BLOG_ERROR:
            return {
                ...state,
                error: payload
            };
        default:
            return { ...initialState, ...state };
    }
};

export default reducer;
